module.exports = __webpack_public_path__ + "static/media/view category.287714ff.svg";